import { GoPlusSmall } from 'react-icons/go';
import { MdKeyboardArrowRight } from 'react-icons/md';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface ContainerProps {
  twoColumns?: boolean;
  multipleColumns?: boolean;
  noBorder?: boolean;
  error?: boolean;
}

interface HeaderProps {
  $empty: boolean;
  twoColumns: boolean;
}

interface ItemsPreviewProps {
  twoColumns?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  border: ${({ noBorder, error }) =>
    noBorder ? 'none' : `1px solid ${error ? ColorPalette.HEX.RedRYB : ColorPalette.HEX.BrightGray}`};
  background-color: ${ColorPalette.HEX.White};
  height: fit-content;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ multipleColumns, twoColumns }) => (!multipleColumns || twoColumns ? 'none' : 'calc(50% - 16px)')};
  }
`;

export const Header: any = styled.div<HeaderProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px;
  cursor: pointer;

  @media ${({ theme }) => theme.device.desktop} {
    max-width: ${({ twoColumns }) => (twoColumns ? 'calc(50% - 16px)' : 'none')};
  }
`;

Header.Placeholder = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: ${ColorPalette.HEX.DimGray};
`;

Header.Title = styled.span`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.listPreviewCard.itemTitle};
`;

Header.Icon = styled.img`
  height: 48px;
  width: 48px;
  margin-right: 14px;
  object-fit: contain;
`;

Header.PlusIcon = styled(GoPlusSmall)<HeaderProps>`
  height: 28px;
  width: 28px;
  color: ${({ theme, $empty }) =>
    $empty ? theme.listPreviewCard.fontColor.empty : theme.listPreviewCard.fontColor.active} !important;
  margin-left: auto;
`;

Header.RightIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
`;

Header.ArrowIcon = styled(MdKeyboardArrowRight)<HeaderProps>`
  height: 20px;
  width: 20px;
  color: ${({ theme, $empty }) =>
    $empty ? theme.listPreviewCard.fontColor.empty : theme.primaryBackgroundColor} !important;
  margin-left: auto;
`;

export const Separator = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.listPreviewCard.separator};
`;

export const ItemsPreview = styled.div<ItemsPreviewProps>`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 0 16px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: ${({ twoColumns }) => (twoColumns ? '1fr 1fr' : '1fr')};
    grid-gap: 16px;
  }
`;

export const ItemsContainer = styled.div`
  cursor: pointer;
`;

export const Item: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 16px 0;

  min-width: 0;
`;

interface IconProps {
  $background: string;
}

Item.Icon = styled.div<IconProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 48px;
  min-height: 48px;
  border-radius: 100%;

  font-size: 16px;
  font-weight: 500;
  line-height: 2;
  color: ${({ theme }) => theme.listPreviewCard.white};

  background-image: ${({ $background }) => $background};
  margin-right: 14px;
`;

Item.ImageIcon = styled.img`
  height: 48px;
  width: 48px;
  margin-right: 14px;
  object-fit: contain;
`;

Item.Text = styled.div`
  flex-direction: column;
  min-width: 0;
`;

Item.Title = styled.span`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.18px;
  color: ${({ theme }) => theme.listPreviewCard.itemTitle};

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

Item.Subtitle = styled.span`
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.listPreviewCard.itemSubtitle};

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;

  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: ${({ theme }) => theme.primaryBackgroundColor};

  cursor: pointer;
`;

export const ErrorMessage = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.RedRYB};
`;
